import { useContext } from 'react'

import { Text } from '@hhgtech/hhg-components/mantine'

import { AirPopulationContext } from './context'

export const Heading = () => {
  const { heading } = useContext(AirPopulationContext)
  if (!heading) return null
  return <Text size="h3">{heading}</Text>
}
